import {getServerTexts as getTexts, initTexts, texts} from '../../../../Localization/texts';

const entity = 'UI_PROGRAMREP';

const en = {
    xxItems: 'XX items',
    clear: 'Clear',
    changeWarning: 'This change will remove all the selected items.',
    confirm: 'OK',
    cancel: 'Cancel',
    over50: 'You selected over 50 items'
};

const he = {
    xxItems: 'XX פריטים',
    clear: 'ניקוי',
    changeWarning: 'שינוי זה ימחק את כל הפריטים שכבר בחרת.',
    confirm: 'אישור',
    cancel: 'ביטול',
    over50: 'בחרת מעל 50 פריטים'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'xxItems',
    2: 'clear',
    3: 'changeWarning',
    4: 'confirm',
    5: 'cancel',
    6: 'over50'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
